import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const FilterSeperator = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.isVertical ? 'column' : 'row')};
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 80px;
  padding: 10px 0;
`;

const LineBase = styled.div`
  visibility: ${props => props.noLine ? 'hidden' : 'visible'};
`

const HorizontalLine = styled(LineBase)`
  width: calc(50% - 30px);
  height: 1px;
  background: ${props => props.theme.color.border};
`;
const VerticalLine = styled(LineBase)`
  height: calc(50% - 15px);
  width: 1px;
  background: ${props => props.theme.color.base3};
`;

// const IndicatorContainer = styled.span`
//   width: 60px;
//   height: 20px;
//   background-color: ${props => props.theme.color.white};
// `;
const Indicator = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: ${props => props.theme.color.secondary};
  color: ${props => props.theme.color.white};
  font-size: ${props => props.theme.size['4']}px;
  line-height: 20px;

  height: 20px;
  width: 40px;
  border-radius: 10px;
  text-align: center;
  overflow: hidden;
`;

const FilterConnectorIndicator = ({ label, layout, noLine }) => {
  const Line = layout === 'horizontal' ? HorizontalLine : VerticalLine;
  const isVertical = layout === 'vertical';
  return (
    <FilterSeperator isVertical={isVertical}>
      <Line noLine={noLine} />

      <Indicator>
        {label}
      </Indicator>

      <Line noLine={noLine} />
    </FilterSeperator>
  );
};

FilterConnectorIndicator.propTypes = {};

export default FilterConnectorIndicator;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/components/FilterConnectorIndicator.js